import HTMLParse from 'react-html-parser'
import Helmet from 'react-helmet'

function Meta({ head_json }) {
  return head_json ? (
    <Helmet>
      {HTMLParse(head_json)}
    </Helmet>
  ) : null
}

export default Meta
